import { render } from "./Logo.vue?vue&type=template&id=782c58db&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=782c58db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782c58db"]])

export default __exports__